import React from "react";
import Row from "react-bootstrap/Row";
//import logo from "../assets/images/logo.png";
import Image from "react-bootstrap/Image";
import Container from "react-bootstrap/Container";

document.body.style.backgroundColor = "#d4bd0f";

const Header = () => {
  return (
    <React.Fragment>
      <Container>
        <Row className="centrado">
          <Image
            src="../assets/images/logo512.png"
            width="180px"
            height="180px"
            fluid
            alt="bordados_zariñana_logo"
          />
        </Row>

        <Row className="centrado">
          <h1 className="encabezado">Bordados Zariñana</h1>
        </Row>

        <Row>
          <div
            style={{
              paddingTop: "1px",
              backgroundColor: "white",
              width: "100%",
              marginLeft: "1.5em",
              marginBottom: "1.5em",
              marginRight: "1.5em",
            }}
          ></div>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Header;
